import React from "react";
import css from "./index.m.css";
import {urlDomainDeal} from "@src/utils/common";

export default (props) => {
  const { imgSrc, cardTitle, cardDesc } = props;
  return (
    <div className={css["update-card"]}>
      <div className={css['update-card-title']}>
        <img src={urlDomainDeal(imgSrc)} />
        {cardTitle}
      </div>
      <div className={css['update-card-desc']}>{cardDesc}</div>
    </div>
  );
};
